import { Base } from "../../../../../base/components/base"
import { Div } from "../../../../../base/components/native/div"
import services from "../../../../../services"
import { TArticle } from "../../../../../types/article"
import { TFAQ } from "../../../../../types/faq"
import { FAQItem } from "./faq-item"
import { addNewFAQStyle, baseStyle, listStyle, titleStyle } from "./faqs-list.style"

export const FAQsList = () => {

    const base = Base()
    base.cssClass(baseStyle)

    const title = Div('لیست سوالات متداول')
    title.cssClass(titleStyle)
    base.append(title)

    const newFAQ = Div('+ افزودن سوال جدید')
    newFAQ.cssClass(addNewFAQStyle)
    newFAQ.el.onclick = () => {
        const faq = {
            key: new Date().getTime().toString(),
            q: 'یک سوال جدید',
            a: 'پاسخ سوال جدید'
        }
        const item = FAQItem(faq)
        item.on('select', (faq: TFAQ) => base.emit('select', faq))
        items.push(item)
        list.append(item)
        base.emit('select', faq)
    }
    base.append(newFAQ)

    const list = Div()
    list.cssClass(listStyle)
    base.append(list)

    list.append(Div('در حال دریافت سوالات متداول...'))

    const items: any[] = []
    services.faqs.all().then(faq => {
        console.log(faq, 'res');

        list.empty()
        faq.items.forEach((faq: TFAQ) => {
            if (!faq || !faq.q || faq.q==='<br>') return
            const item = FAQItem(faq)
            item.on('select', (faq: TFAQ) => base.emit('select', faq))
            items.push(item)
            list.append(item)
        })
    })

    return Object.assign(base, {
        add(faq: TFAQ) {
            const item = FAQItem(faq)
            item.on('select', (faq: TFAQ) => base.emit('select', faq))
            list.append(item)
        },
        update(faq: TFAQ) {
            const found = items.find(item => item.getKey() === faq.key)

            if (found) {
                found.update(faq)
            } else {
                const item = FAQItem(faq)
                item.on('select', (faq: TFAQ) => base.emit('select', faq))
                items.push(item)
                list.append(item)
            }

        },
        remove(faqKey: string) {
            const found = items.find(item => item.getKey() === faqKey)
            if (found) {
                found.remove()
            }

        },

        getValue() {
            return {
                items: items.map(item => item.getValue())
            }
        }
    })
}